import React from "react";
import { LockSimpleIcon, WarningCircleIcon } from "@phosphor-icons/react";
import { Tooltip } from "@mui/material";
import type { UnreadableReason } from "@/components/FpPages/Documents/browser/api";

interface UnreadableFileIndicatorProps {
  /** Why the file cannot be read (#11277). */
  reason: UnreadableReason;
  /** The words the row shows for it, which the tooltip and the glyph's
   *  accessible name repeat. */
  label: string;
}

/** A passive mark beside the name of a file Finpilot cannot read: a lock for
 *  a password-protected Office file, a warning for one that is damaged or not
 *  what its name says. It sits where `LockedFileIndicator` sits and is drawn
 *  the same way (14px, secondary ink, never wrapping away from the name), but
 *  it offers no unlock: no password opens these files here. */
const UnreadableFileIndicator: React.FC<UnreadableFileIndicatorProps> = ({
  reason,
  label,
}) => {
  const Glyph = reason === "encrypted" ? LockSimpleIcon : WarningCircleIcon;
  return (
    <Tooltip title={label} placement="top">
      <span className="inline-flex shrink-0 items-center">
        <Glyph
          size={14}
          weight="regular"
          role="img"
          aria-label={label}
          className="text-[#6E7480]"
        />
      </span>
    </Tooltip>
  );
};

export default UnreadableFileIndicator;
